const RTL = "֑-߿יִ-﷽ﹰ-ﻼ";
const LTR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿";
const isRtlRegex = new RegExp("^[^" + LTR + "]*[" + RTL + "]");
const isLtrRegex = new RegExp("^[^" + RTL + "]*[" + LTR + "]");
const emojiRegex = /\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]/g;
const getTextDirection = (text) => {
  if (!text) {
    return "auto";
  }
  const plainText = text.replace(emojiRegex, "");
  if (isRtlRegex.test(plainText)) {
    return "rtl";
  }
  if (isLtrRegex.test(plainText)) {
    return "ltr";
  }
  return "auto";
};
export {
  getTextDirection
};
//# sourceMappingURL=get-text-direction.js.map
